invHdApp.controller('BillingController', ['$scope', 'Billing', '$location', '$routeParams', '$filter', '$translate',
  function ($scope, Billing, $location, $routeParams, $filter, $translate) {
    $scope.deleted = [];

    $scope.invoiceType = $location.url().replace(/^\/|\/$/g, '');

    $scope.selectAll = function (select) {
      if (select) {
        $scope.deleted = [];
        for (let i = 0; i < $scope.data.invoices.data.length; i++) {
          $scope.deleted.push($scope.data.invoices.data[i].id);
        }
      } else {
        $scope.deleted = [];
      }
    };

    $scope.filterData = {
      station_id: [],
      price: '',
      vehicle: [],
      page: 1,
      invoice_type: $scope.invoiceType,
      date: {
        startDate: null,
        endDate: null
      }
    }

    $scope.clearFilter = function (page) {
      $scope.filterData = {
        station_id: [],
        price: '',
        vehicle: [],
        page: 1,
        invoice_type: $scope.invoiceType,
        date: {
          startDate: null,
          endDate: null
        }
      }
      $scope.all();
    }

    $scope.$on('refresh_data', function () {
      console.log('refreshing map...')
      $scope.all();
    }, true);

    $scope.$on('new_data', function () {
      $scope.invoice = {}
      $scope.new();
      $('#invoiceDetail').modal('hide');
      $('#newInvoice').modal('show');
    }, true);

    $scope.editInvoice = function (page) {
      $scope.new();
      $('#invoiceDetail').modal('hide');
      $('#newInvoice').modal('show');
    }

    $scope.getPage = function (page) {
      $scope.filterData.page = page;
      $scope.all();
    }

    $scope.all = function (type) {
      Billing.all($scope.filterData).success(function (data, status, headers, config) {
        $scope.data = data;

        if (type && type == 'open') {
          var tempInvoice = $scope.data.invoices.data.find(function (element) {
            return element.id == $scope.invoice.id;
          })
          $scope.openDetail(tempInvoice);
        }
      });
    }

    $scope.get = function () {
      Billing.get($routeParams.id).success(function (data, status, headers, config) {
        $scope.data = data;
        jQuery('#date').datetimepicker({
          timepicker: false,
          datepicker: true,
          format: 'Y-m-d'
        });
      });
    }

    $scope.new = function () {
      Billing.new().success(function (data, status, headers, config) {
        jQuery('#date').datetimepicker({
          timepicker: false,
          datepicker: true,
          format: 'Y-m-d'
        });
      });
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        Billing.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.invoices.data.indexOf($filter('filter')($scope.data.invoices.data, {
              id: $scope.deleted[i]
            })[0]);
            if (index > -1)
              $scope.data.invoices.data.splice(index, 1);
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.save = function () {
      if ($scope.invoice.id) {
        $scope.update();
      } else {
        Billing.save($scope.invoice).success(function (data, status, headers, config) {
          $scope.data = data;
          Messenger().post(data.message);
          $('#newInvoice').modal('hide');
          $scope.all();
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.update = function () {
      Billing.update($scope.invoice).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post(data.message);
        $('#newInvoice').modal('hide');
        $scope.all('open');

      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.openDetail = function (data) {
      $scope.invoice = data;
      $('#invoiceDetail').modal('show');
    }

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };
    $scope.invoice = {
      count: 3,
      invoices: []
    }
    jQuery('#date').datetimepicker({
      timepicker: false,
      datepicker: true,
      format: 'Y-m-d'
    });

    $scope.showCompletedOrders = function (invoice) {
      if($scope.invoiceType == 'invoice') {
        var data = {
          invoice_id: invoice.id,
        }
      }else {
        var data = {
          collection_id: invoice.id,
        }
      }
      var url = 'orders?data=' + JSON.stringify(data);
      window.open(url, '_blank');
    }

    $scope.openPayment = function (payment) {
      $scope.payment = payment;
      jQuery('#payment_date').datetimepicker({
        timepicker: false,
        datepicker: true,
        format: 'Y-m-d'
      });
      $('#invoiceDetail').modal('hide');
      $('#newInvoicePayment').modal('show');
    }

    $scope.newPayment = function () {
      $scope.payment = {};
      jQuery('#payment_date').datetimepicker({
        timepicker: false,
        datepicker: true,
        format: 'Y-m-d'
      });
      $('#invoiceDetail').modal('hide');
      $('#newInvoicePayment').modal('show');
    }

    $scope.addPayment = function () {
      if ($scope.payment.id) {
        $scope.updatePayment();
      } else {
        $scope.payment.invoice_id = $scope.invoice.id;
        $scope.payment.price = $scope.payment.rate * $scope.payment.qty;
        Billing.addPayment($scope.payment).success(function (data, status, headers, config) {
          $scope.data = data;
          Messenger().post(data.message);
          $('#newInvoicePayment').modal('hide');
          $scope.all('open');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.updatePayment = function () {
      $scope.payment.price = $scope.payment.rate * $scope.payment.qty;
      Billing.updatePayment($scope.payment).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post(data.message);
        $('#newInvoicePayment').modal('hide');
        $scope.all('open');
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.deletePayment = function (payment) {
      if (confirm($translate.instant("ARE_U_SURE_DELETE"))) {
        Billing.deletePayment(payment.id).success(function (data, status, headers, config) {
          Messenger().post(data.message);
          $scope.all('open');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.getPrice = function(payment) {
      try {
        $scope.payment.price = $scope.payment.rate * $scope.payment.qty;
      } catch (error) {
      }
    }

  }
]);